import PreviewSectionHead from "pages/PreviewPage/PreviewSectionHead/PreviewSectionHead";

export default PreviewSectionHead;
